export default __webpack_public_path__ + "static/media/landscape_screen_1920x1080px.66457c2b.png";